<template>
  <v-card class="tender-card" :class="{ 'tender-card': highlighted }">
    <div v-if="!$vuetify.breakpoint.xsOnly">
      <v-img
        v-if="image"
        :src="image"
        class="white--text cursor-pointer"
        @click.prevent="chooseTender"
        height="200px"
        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
      >
        <v-card-title class="fill-height align-end"></v-card-title>
      </v-img>

      <div v-else class="cursor-pointer image-placeholder"></div>
    </div>
    <div v-else>
      <router-link :to="{ path: tenderDetailRoutePath + '/' + (tender.id || tender.mpID) }">
        <v-img
          v-if="image"
          :src="image"
          class="white--text cursor-pointer"
          height="200px"
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
        >
          <v-card-title class="fill-height align-end"></v-card-title>
        </v-img>

        <div v-else class="cursor-pointer image-placeholder"></div>
      </router-link>
    </div>
    <v-card-actions
      style="height: 100%;"
      class="pt-3 pb-3 d-flex"
      :class="{ 'blue lighten-5': highlighted }"
    >
      <v-layout
        @click.prevent="chooseTender"
        column
        justify-space-between
        class="tender-card__name cursor-pointer"
        style="word-break: break-word; height: 100%"
      >
        <span :title="tender.title">
          {{ tender.title }}
        </span>
        <span class="mt-3 tender-card__date" v-if="tender.tenderPeriod">
            <template v-if="tender.status === 'active.tendering' && tender.tenderPeriod.endDate">
              {{ tender.tenderPeriod.endDate | moment('ll') }}
            </template>
            <template v-else-if="tender.dateModified">
              {{ tender.dateModified | moment('ll') }}
            </template>
            <span class="ml-1" :style="{ color: formattedStatus.color, textTransform: 'capitalize' }">
              {{ formattedStatus.text }}
            </span>
        </span>
      </v-layout>
      <v-menu offset-y left>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" text class="cursor-pointer">more_vert</v-icon>
        </template>
        <v-list dark>
          <v-list-item @click="toggleStarredStatus(tender.id)">
            <v-list-item-title>
              <translate v-if="isTenderStarred"> Remove from favorite</translate>
              <translate v-else> Add to favorite</translate>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-actions>
  </v-card>
</template>

<script>
import starredMixin from '@/mixins/starredMixin'
import GlobalFunctions from '@/utils/GlobalFunctions'
import subscriptions from '@/services/apiCalls/subscriptions'
import getStatusColor from '@/utils/getStatusColor'

export default {
  name: 'TenderCard',

  mixins: [starredMixin],

  props: {
    tender: {
      type: Object,
      required: true,
    },

    highlighted: {
      type: Boolean,
      default: false,
    },

    tenderDetailRoutePath: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      image: null,
    };
  },

  computed: {
    isTenderStarred() {
      return this.$store.state.starredTendersIds.includes(this.tender.id)
    },

    formattedStatus() {
      const status = this.tender.status;
      if (!status) {
        return {};
      }
      return {
        color: getStatusColor(status),
        text: status.includes('.') ? status.split('.')[1] : status,
      }
    }
  },

  created() {
    this.setImage();
    this.subscribeOnTenderChanges();
  },

  methods: {
    chooseTender() {
      this.$emit('choose-tender')
    },

    setImage() {
      let img = '';
      if (this.tender.items && this.tender.items[0].classification.id) {
        img = GlobalFunctions.findCpvImage(this.tender.items[0].classification.id);
      } else if (this.tender.category) {
        img = GlobalFunctions.findCpvImage(this.tender.category);
      }
      if (img) {
        this.image = require('@/assets/img/tenderCpvImg/' + img);
      }
    },

    subscribeOnTenderChanges() {
      if (this.tender.mpID) {
        const subscription = subscriptions.onTenderChanged(this.tender.mpID).subscribe({
          next: (value) => {
            this.$emit('update', value);
          },
          error: error => console.error(error),
        });
        this.$once('hook:beforeDestroy', () => {
          subscription.unsubscribe();
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.tender-card {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  &--highlighted {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  }

  &__name {
    font-size: 14px;
    overflow-wrap: break-word;
    width: 100%;
  }

  &__date {
    color: #656565;
    font-size: 12px;
    white-space: nowrap;
  }

  .image-placeholder {
    height: 200px;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.5));
  }
}
</style>
